<template style="background-color: transparent; position:relative;">
	<StaticViewComponent :content="content"></StaticViewComponent>
</template>

<script>

import StaticViewComponent from "@/components/StaticViewComponent";

export default {
	props: {},
	metaInfo: {
		title: 'Согласие на обработку персональных данных',
		meta: [
			{name: 'theme-color', content: '#F7F3ED'},
			{name: 'apple-mobile-web-app-capable', content: 'yes'},
			{name: 'apple-mobile-web-app-status-bar-style', content: 'yes'},
		],
	},
	components: {
		StaticViewComponent,
	},
	data() {
		return {
			content: `
				<h4 style="font-weight: bold; text-align: center; margin-bottom: 2em; color: #2C3333">СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ</h4>
				<p>Настоящим, я, действуя свободно, своей волей и в своем интересе, а также подтверждая свою дееспособность, предоставляя данные о себе, даю согласие Обществу с ограниченной ответственностью &laquo;Три сферы&raquo;, ИНН 7627051991, адрес: Ярославская область, Ярославский район, пос. Дубки, ул. Школьная, д. 1 (далее &mdash; Оператор) на обработку следующих моих персональных данных, указанных мною как при бронировании Проживания на сайте Оператора, так и предоставленные через личный кабинет на сайте Оператора или иным способом, с целью оформления и исполнения бронирования Проживания и/или оформления и оказания Услуг в Средстве/Объекте размещения Оператора:</p>
				<p>&ndash; фамилия, имя, отчество (при наличии);</p>
				<p>&ndash; контактная информация (номер телефона, электронный адрес);</p>
				<p>&ndash; гражданство;</p>
				<p>&ndash; пол;</p>
				<p>&ndash; период пребывания (дата заезда, дата выезда, цель въезда, № комнаты);</p>
				<p>&ndash; условия проживания;</p>
				<p>&ndash; адрес регистрации;</p>
				<p>&ndash; информация о гостях;</p>
				<p>&ndash; дата рождения (число/месяц/год);</p>
				<p>&ndash; данные документа, удостоверяющего личность (серия, номер, дата выдачи, код подразделения, орган, выдавший документ, страна рождения, регион рождения, район, город, населенный пункт).</p>
				<p>Для достижения указанной цели Оператор может осуществлять любые действия (операции) или совокупности действий (операций), совершаемых с использованием средств автоматизации или без использования таких средств с персональными данными, указанными выше, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (предоставление, доступ), блокирование, удаление, уничтожение персональных данных.</p>
				<p>Я даю согласие Оператору на передачу (предоставление, доступ) персональных данных, указанных выше, в адрес следующего юридического лица, действующего по поручению Оператора: ООО &laquo;ТРЭВЕЛ ЛАЙН СИСТЕМС&raquo;, ИНН 1215180595, ОГРН 1141215003214, юридический адрес: 424031, Республика Марий Эл, г. Йошкар-Ола, ул. Комсомольская, д. 112 в целях автоматизации бизнес-процессов, централизованного хранения и управления данными Оператора, а также осуществление с ними следующих действий (операций): сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (предоставление, доступ), блокирование, удаление, уничтожение.</p>
				<p>Я подтверждаю, что предоставленные мной персональные данные являются точными, актуальными и достоверными, также обязуюсь своевременно информировать Оператора об изменениях в моих персональных данных по адресу электронной почты: info@yardelfin.ru, либо в письменной форме на адрес: Ярославская область, Ярославский район, пос. Дубки, ул. Школьная, д. 1.</p>
				<p>Настоящее согласие вступает в силу с момента его предоставления, путем проставления галочки на сайте Оператора.</p>
				<p>В случае достижения цели обработки персональных данных или отзыва согласия субъектом персональных данных Оператор обязан прекратить обработку персональных данных и уничтожить персональные данные в срок, не превышающий тридцати дней с даты достижения цели обработки персональных данных или отзыва согласия.</p>
				<p>В соответствии с положениями ч. 2 ст. 9 Федерального закона от 27 июля 2006 г. N 152-ФЗ &laquo;О персональных данных&raquo; оставляю за собой право отозвать данное согласие посредством направления такого отзыва по адресу электронной почты: info@yardelfin.ru, либо в письменной форме на адрес: Ярославская область, Ярославский район, пос. Дубки, ул. Школьная, д. 1.</p>
				<p>Я предупрежден(а), что в случае отзыва согласия на обработку персональных данных Оператор вправе продолжить обработку персональных данных без согласия при наличии оснований, указанных в пп. 2-11 ч. 1 ст. 6, ч. 2 ст. 10 Федерального закона от 27 июля 2006 г. N 152-ФЗ &laquo;О персональных данных&raquo;.</p>
`
		}
	},
	computed: {

	},
	methods: {}
};
</script>

<style scoped>
.back_to_home_box {
	position: fixed;
	right: 15px;
	top: 55px;
	z-index: 1000;
}

.back_to_home,
.back_to_home:hover {
	color: #333333;
	text-decoration: none;
	font-size: 80px;
	line-height: 50px;
	opacity: 0.9;
}

.back_to_home:hover {
	opacity: 0.5;
}

p { text-indent: 2em; color: #333333; }

h4, .section-heading { color: #2C3333; }
</style>
